// third party imports
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// internal rebet imports
import "./stylesAddAdmin.css";
import { API_ROUTES } from "../../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { handleExpiredTokenError } from "../../../utils/ErrorUtils";
import { ADMIN_TYPES, SIDER_TABS } from "../../../utils/Constants";

// component imports
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import AppContext from "../../../context/AppContext";
import DropDown from "../../CommonComponents/DropDown/DropDown";

const dropdownOptions = {
  "customer-support": "Customer Support",
  "super-admin-v2": "Super Admin",
  "compliance-agent": "Compliance",
};

const dropdownOptionsENUM = {
  "Customer Support": "customer-support",
  "Super Admin": "super-admin-v2",
  "Compliance": "compliance-agent",
};

const AddAdmin = () => {
  // non-state variables
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const { setActiveSidebarTab } = useContext(AppContext);

  // state variables
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isApiSending, setIsApiSending] = useState(false);
  const [lastApiCallError, setLastApiCallError] = useState(false);
  const [lastApiErrorMessage, setLastApiErrorMessage] = useState("");
  const [lastApiCallSuccess, setLastApiCallSuccess] = useState(false);
  const [lastApiCallSuccessMessage, setLastApiCallSuccessMessage] =
    useState("");
  const [submitButtonActive, setSubmitButtonActive] = useState(false);
  const [selectedAdminType, setSelectedAdminType] = useState("Super Admin");

  // use effects
  useEffect(() => {
    if (
      email?.length !== 0 &&
      password?.length !== 0 &&
      firstName?.length !== 0 &&
      lastName?.length !== 0 &&
      selectedAdminType
    ) {
      setSubmitButtonActive(true);
    } else {
      setSubmitButtonActive(false);
    }
  }, [email, password, firstName, lastName, selectedAdminType]);

  // api functions
  const createAdmin = async () => {
    setIsApiSending(true);
    setLastApiCallError(false);
    setLastApiErrorMessage("");
    setLastApiCallSuccess(false);
    setLastApiCallSuccessMessage("");

    const params = {
      username: email?.split("@")[0],
      password: password,
      email: email,
      first_name: firstName,
      last_name: lastName,
      address: "NH",
      group_name: dropdownOptionsENUM[selectedAdminType]
    };

    try {
      await PrivateAdminPanelInstance?.post(API_ROUTES?.CREATE_ADMIN, params);

      setLastApiCallSuccess(true);
      setLastApiCallSuccessMessage("Admin create successfully!");
      setIsApiSending(false);
      setEmail("");
      setPassword("");
      setFirstName("");
      setLastName("");
    } catch (error) {
      console.log("error creating admin", error);
      console.log("error creating admin", error?.resposne);
      setIsApiSending(false);
      setLastApiCallError(true);
      setLastApiErrorMessage(error?.response?.data?.message);
      handleExpiredTokenError(navigate, error?.response);
    }
  };

  // helper functions
  const handleEmailChange = (event) => {
    setEmail(event?.target?.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event?.target?.value);
  };

  const handleFirstNameChange = (event) => {
    setFirstName(event?.target?.value);
  };

  const handleLastNameChange = (event) => {
    setLastName(event?.target?.value);
  };


  const handleCreateAdminPressed = () => {
    if (submitButtonActive) {
      createAdmin();
    }
  };

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.ADMIN, "Admin");
  }, [setActiveSidebarTab]);

  return (
    <div className="add-admin">
      <div className="add-admin-header-text">Create Admin</div>

      <div className="admin-permissions-row">
        <input
          type="text"
          placeholder="Email..."
          className="add-admin-field"
          value={email}
          onChange={handleEmailChange}
        />
      </div>
      <div className="admin-permissions-row">
        <input
          type="text"
          placeholder="Password with 8 characters, symbol, #, and capital..."
          className="add-admin-field"
          value={password}
          onChange={handlePasswordChange}
        />
      </div>
      <div className="admin-permissions-row">
        <input
          type="text"
          placeholder="First name..."
          className="add-admin-field"
          value={firstName}
          onChange={handleFirstNameChange}
        />
      </div>
      <div className="admin-permissions-row">
        <input
          type="text"
          placeholder="Last name..."
          className="add-admin-field"
          value={lastName}
          onChange={handleLastNameChange}
        />
      </div>
      <div className="admin-permissions-row column">
        <span className="admin-permissions-label">Select the Agent Status</span>
        <DropDown
          drop_down_options={dropdownOptions}
          selected_value={selectedAdminType}
          set_selected_value={setSelectedAdminType}
          custom_placeholder="Agent Status"
        />
      </div>

      <div className="create-admin-button-container">
        <button
          className={
            submitButtonActive ? "submit-button" : "submit-button-inactive"
          }
          onClick={handleCreateAdminPressed}
        >
          {isApiSending ? (
            <RebetLoader height={"50px"} width={"50px"} />
          ) : (
            "Create Admin"
          )}
        </button>

        {lastApiCallError ? (
          <div className="error-message">{lastApiErrorMessage}</div>
        ) : null}

        {lastApiCallSuccess ? (
          <div className="success-message">{lastApiCallSuccessMessage}</div>
        ) : null}
      </div>
    </div>
  );
};

export default AddAdmin;
